export const caretDownSvg = (
  <svg
    data-testid="ock-caretDownSvg"
    role="img"
    aria-label="ock-caretDownSvg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.95 4.85999L8.00001 9.80999L3.05001 4.85999L1.64001 6.27999L8.00001 12.64L14.36 6.27999L12.95 4.85999Z"
      className="fill-ock-foreground"
    />
  </svg>
);
